module.exports = __webpack_public_path__ + "static/media/firebase-realtime-database.6bdbc02d.svg";